
import Vue from 'vue';
import * as InterfaceStore from '@/store/search/form/interface';
import * as UIStore from '@/store/search/ui';
import * as RootStore from '@/store/search/';

import QueryForm from '@/pages/search/form/QueryForm.vue';
import QuerySummary from '@/pages/search/results/QuerySummary.vue';
import Results from '@/pages/search/results/Results.vue';
import Spinner from '@/components/Spinner.vue';

import {wideView} from '@/pages/search/form/QueryFormSettings.vue';

export default Vue.extend({
	components: {
		QueryForm,
		QuerySummary,
		Results,
		Spinner
	},
	data: () => ({ wideView, }),
	computed: {
		loadingState() { return RootStore.get.status().status; },
		loadingMessage() { return RootStore.get.status().message; },

		resultsVisible(): boolean { return InterfaceStore.getState().viewedResults != null; },
		debugQuery: RootStore.get.blacklabParameters
	},
});
